module.exports = __webpack_public_path__ + "static/media/icon-minus.8aef3297.svg";